import React, {ReactInstance, useEffect, useLayoutEffect, useRef, useState} from 'react'
import './todos.less'
import {useIntl} from 'react-intl'
import {Button, Input, Popconfirm, Popover, Radio, Select, Space} from 'antd'
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import {EmEmoji} from '../emoji/EmEmoji'
import {ToDoTypeOption} from '../../entities/journalRecord'

// generic over the option so an editor holding a saved CustomType gets one back
export type ToDoTypeInputProps<T extends ToDoTypeOption> = {
  userType: T
  setUserType: (newType: T) => void
  onEmojiDropdownVisibleChange?: (visible: boolean) => void
}

export function ToDoTypeInput<T extends ToDoTypeOption>(props: ToDoTypeInputProps<T>) {
  const intl = useIntl()
  const [isPickerVisible, setIsPickerVisible] = useState(false)
  const pickerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const onVisibleChange = props.onEmojiDropdownVisibleChange
    if (typeof onVisibleChange === 'function') {
      if (isPickerVisible) {
        onVisibleChange(true)
      } else {
        // TODO: antd uses setTimeout with 10ms delay before triggering dropdown visibility update
        // so to counter that we have to introduce our own timeout which is also based on
        // animation delay :(
        window.setTimeout(() => onVisibleChange(false), 400)
      }
    }
  }, [isPickerVisible])

  const picker = (
    <div
      ref={pickerRef}
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      <Picker
        ref={pickerRef}
        data={data}
        onEmojiSelect={(e: {id: string}) => {
          props.setUserType({...props.userType, icon: e.id})
          setIsPickerVisible(false)
        }}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation()
        }}
      />
    </div>
  )

  useLayoutEffect(() => {
    const globalClickHandler = (e: MouseEvent) => {
      if (!pickerRef.current) {
        return
      }
      if (pickerRef.current.contains(e?.target as HTMLElement)) {
        return
      }

      if (isPickerVisible) {
        setIsPickerVisible(false)
      }
    }

    document.addEventListener('click', globalClickHandler)
    return () => document.removeEventListener('click', globalClickHandler)
  })

  return (
    <span style={{display: 'flex'}} onClick={(e) => e.stopPropagation()}>
      <Popover
        placement="bottomLeft"
        content={picker}
        trigger={[]}
        open={isPickerVisible}
        onOpenChange={(open) => setIsPickerVisible(open)}
      >
        <Button onClick={(e) => setIsPickerVisible(true)}>
          <EmEmoji id={props.userType.icon} size="1em"></EmEmoji>
        </Button>
      </Popover>

      <div style={{width: '100%', position: 'relative'}}>
        <Input
          disabled={false}
          value={props.userType.name}
          readOnly={false}
          placeholder={intl.formatMessage({id: 'newTypeName'})}
          onChange={(e) => {
            props.setUserType({...props.userType, name: e.target.value})
          }}
        />
      </div>
    </span>
  )
}
